// Extraído de utils/index.tsx para evitar ciclo (selectApplication importa isto).
export enum applicationListRules {
  PORTAL_TRADING = "portal_trading",
}
